import { JobsAppliedByTheUserComponent } from './../../widget/jobs-appliedBy-The-user/jobs-appliedBy-The-user.component';
import { JobInviteComponent } from './../../widget/job-invite/job-invite.component';
import { ResumeRequestComponent } from './../../widget/resume-request/resume-request.component';
import { InvitesCerditsComponent } from './../../widget/invites-cerdits/invites-cerdits.component';
import { FeaturedJobsComponent } from './../../widget/featured-jobs/featured-jobs.component';
import { FeaturedCandidateComponent } from './../../widget/featured-candidate/featured-candidate.component';
import { SuggestedCandidateComponent } from './../../widget/suggested-candidate/suggested-candidate.component';
import { SuggestedJobComponent } from './../../widget/suggested-job/suggested-job.component';
import { CandidateYouMightBeIntrestedInComponent } from './../../widget/candidate-you-might-be-intrested-in/candidate-you-might-be-intrested-in.component';
import { JobSubmitSkillfilterComponent } from './../../widget/job-submit-skillfilter/job-submit-skillfilter.component';
import { SponsoredAdsComponent } from './../../widget/sponsored-ads/sponsored-ads.component';
import { PromotedAdsComponent } from './../../widget/promoted-ads/promoted-ads.component';
import { PeopleWithSimilarNameComponent } from './../../widget/people-with-similar-name/people-with-similar-name.component';
import { WelcomeWidgetComponent } from './../../widget/welcome-widget/welcome-widget.component';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Component, ComponentRef, Injectable, Injector, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

// Injection token for passing widget data in Angular 15
import { InjectionToken } from '@angular/core';
export const WIDGET_DATA = new InjectionToken<any>('WIDGET_DATA');
import { CareonlineTodayComponent, CollegueYouMayKnowComponent, CommunityAdminComponent, ConnectionsComponent, FollowCareonlineComponent, HashtagsYouMayLikeComponent, InviteCollegueComponent, PeopleYouMayKnowComponent, ProfileCompletionComponent, SimilarBusinessNearYouComponent, SimilarCommunityComponent, TrendingCommunityComponent, TrendingHashtagComponent, TrendingPostComponent, VisitorsComponent, WidgetComponent, JobsYouMightBeIntrestedInComponent, CommonProfileInfoComponent } from 'src/app/widget';
import { SocialMediaComponent } from 'src/app/widget/social-media/social-media.component';
import { CopywriteComponent } from 'src/app/widget/copywrite/copywrite.component';
import { EmptyWidgetComponent } from 'src/app/widget/empty-widget/empty-widget.component';
import { HashtagsToFollowComponent } from 'src/app/widget/hashtags-to-follow/hashtags-to-follow.component';
import { NodataFoundComponent } from 'src/app/widget/nodata-found/nodata-found.component';
import { PeopleInyourNetworkComponent } from 'src/app/widget/people-inyour-network/people-inyour-network.component';
import { BusinessbusinessComplteDataComponent } from 'src/app/widget/business-profile-complete/business-profile-complete.component';
import { CommunityProfileCompleteComponent } from 'src/app/widget/community-profile-complete/community-profile-complete.component';
import { FollowerComponent } from 'src/app/widget/follower/follower.component';
import { CardComponent } from 'src/app/widget/card/card.component';
import { BToFollowComponent } from 'src/app/widget/b-to-follow/b-to-follow.component';
import { CandidateInviteComponent } from 'src/app/widget/candidate-invite/candidate-invite.component';
import { ResumeRequestSentComponent } from 'src/app/components/job-module/resume-request-sent/resume-request-sent.component';
import { JobInviteSentComponent } from 'src/app/widget/job-invite-sent/job-invite-sent.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-suggestions',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: './suggestions.component.html',
  styleUrls: ['./suggestions.component.scss']
})
export class SuggestionsComponent implements OnInit, OnChanges, OnDestroy {
  searchMenudata;
  pathData;
  user;
  @Input() selectedMenu: any = { menu: '', widgetName: '' };
  widget: any;
  // Initialize with MAX viewType since suggestions page always shows expanded view
  sendWidgetInfo: any = {
    maxMin: { viewType: 'MAX' }
  };
  countSubscription !: Subscription;
  landingsidesticky1: boolean = false;
  landingsidesticky2: boolean = false;
  renderNDC: boolean = true;
  dynamicComponent !: any;
  currentComponentInstance !: ComponentRef<any>;
  widgetInjector !: Injector;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public provider: countProvider,
    private injector: Injector
  ) {

    this.updateWidget();

    this.router.events.subscribe(routerEvent => {
      if (routerEvent instanceof NavigationEnd) {  
        // force ndc-component to update component instance 
        this.renderNDC = false; 
        setTimeout(() => { 
            this.renderNDC = true;
         }, 100); 
      }
    });


  }

  updateWidget(){ 
    this.widget = {
      "BusinessToFollowComponent": BToFollowComponent,
      "CommunityProfileCompleteComponent": CommunityProfileCompleteComponent,
      "BusinessProfileCompleteComponent": BusinessbusinessComplteDataComponent,
      "CareonlineTodayComponent": CareonlineTodayComponent,
      "CollegueYouMayKnowComponent": CollegueYouMayKnowComponent,
      "WelcomeWidgetComponent": WelcomeWidgetComponent,
      "CommunityAdminComponent": CommunityAdminComponent,
      "ConnectionsComponent": ConnectionsComponent,
      "FollowCareonlineComponent": FollowCareonlineComponent,
      "HashtagsYouMayLikeComponent": HashtagsYouMayLikeComponent,
      "InviteCollegueComponent": InviteCollegueComponent,
      "PeopleYouMayKnowComponent": PeopleYouMayKnowComponent,
      "ProfileCompletionComponent": ProfileCompletionComponent,
      "SimilarBusinessNearYouComponent": SimilarBusinessNearYouComponent,
      "SimilarCommunityComponent": SimilarCommunityComponent,
      "TrendingCommunityComponent": TrendingCommunityComponent,
      "TrendingHashtagComponent": TrendingHashtagComponent,
      "PeopleWithSimilarNameComponent": PeopleWithSimilarNameComponent,
      "TrendingPostComponent": TrendingPostComponent,
      "VisitorsComponent": VisitorsComponent,
      "WidgetComponent": WidgetComponent,
      "JobsYouMightBeIntrestedInComponent": JobsYouMightBeIntrestedInComponent,
      "CommonProfileInfoComponent": CommonProfileInfoComponent,
      "PromotedAdsComponent": PromotedAdsComponent,
      "SponsoredAdsComponent": SponsoredAdsComponent,
      "PeopleInyourNetworkComponent": PeopleInyourNetworkComponent,
      "HashtagsToFollowComponent": HashtagsToFollowComponent,
      "EmptyWidgetComponent": EmptyWidgetComponent,
      "CopywriteComponent": CopywriteComponent,
      "NodataFoundComponent": NodataFoundComponent,
      "SocialMediaComponent": SocialMediaComponent,
      "FollowerComponent": FollowerComponent,
      "CardComponent": CardComponent,
      "JobSubmitSkillfilterComponent": JobSubmitSkillfilterComponent,
      "CandidateYouMightBeIntrestedInComponent": CandidateYouMightBeIntrestedInComponent,
      "SuggestedJobComponent": SuggestedJobComponent,
      "SuggestedCandidateComponent": SuggestedCandidateComponent,
      "FeaturedCandidateComponent": FeaturedCandidateComponent,
      "FeaturedJobsComponent": FeaturedJobsComponent,
      "InvitesCerditsComponent": InvitesCerditsComponent,
      "ResumeRequestComponent": ResumeRequestComponent,
      "JobInviteComponent": JobInviteComponent,
      "CandidateInviteComponent": CandidateInviteComponent,
      "ResumeRequestSentComponent": ResumeRequestSentComponent,
      "JobInviteSentComponent": JobInviteSentComponent,
      "JobsAppliedByTheUserComponent": JobsAppliedByTheUserComponent
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('SuggestionsComponent ngOnChanges:', changes);
    if (changes.selectedMenu?.currentValue) {
      this.selectedMenu = { ...changes.selectedMenu.currentValue };
      console.log('SuggestionsComponent: Updated selectedMenu from @Input:', this.selectedMenu);
      this.dynamicComponent = this.widget[this.selectedMenu.widgetName];

      // Update sendWidgetInfo with data from selectedMenu when input changes
      // This ensures widgets have data even before queryParams subscription fires
      // Always set maxMin.viewType to MAX for suggestions page (expanded view)
      this.sendWidgetInfo = {
        ...this.sendWidgetInfo,
        widgetDesc: this.selectedMenu.menu || this.sendWidgetInfo.widgetDesc,
        maxMin: { "viewType": "MAX", "master": this.sendWidgetInfo.inputData || this.pathData || 'HOME' }
      };
      this.createWidgetInjector();
    }
  }

  // Create a custom injector to pass data to dynamically loaded widgets (Angular 15 pattern)
  private createWidgetInjector(): void {
    this.widgetInjector = Injector.create({
      providers: [
        { provide: WIDGET_DATA, useValue: this.sendWidgetInfo }
      ],
      parent: this.injector
    });
  }

  ngOnDestroy(): void {
  }

  componentCreated(e: ComponentRef<any>) {
    this.currentComponentInstance = e;
  }

  ngOnInit() {
    this.route.queryParams.subscribe((res) => {
      console.log('SuggestionsComponent: Received query params:', res);
      this.pathData = res.master;

      // Set the dynamic component based on widgetName from query params
      if (res.widgetName && this.widget[res.widgetName]) {
        this.dynamicComponent = this.widget[res.widgetName];
      }

      // Set selectedMenu from query params for direct route navigation
      // This ensures the title shows when navigating via URL (not just via parent input)
      if (res.menu || res.widgetName) {
        this.selectedMenu = {
          menu: res.menu,
          widgetName: res.widgetName
        };
        console.log('SuggestionsComponent: Set selectedMenu:', this.selectedMenu);
      }

      // Pass all required inputs to the widget component
      // Query params contain: data, master, menu, masterMenu, widgetName
      this.sendWidgetInfo = {
        maxMin: { "viewType": "MAX", "master": res.masterMenu },
        inputData: res.masterMenu,      // inputData comes from masterMenu
        page: res.master,               // page comes from master
        widgetDesc: res.menu,           // widgetDesc comes from menu (the title)
        suggestion: res.data            // suggestion/data field
      };
      this.createWidgetInjector();
    });
  } 
}




@Injectable({
  providedIn: 'root'
})
export class countProvider {
 
  private benefitsData: any = {};
  private widget = {}
  constructor(){}

  setCount(val: number , key: string) {
      this.widget[key] = val; 
  }
  
  getCount(key:string) {
    if(this.widget[key] != undefined){
      return this.widget[key];
    }
    return 0;
  }

  clear(){
    this.widget = {}; 
  }


  setBenefits(data: any) {
    this.benefitsData = data;
  }

  getBenefits() {
    return this.benefitsData;
  }

  clearBenefits() {
    this.benefitsData = {};
  }


}
